var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoin2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 287,
    height: 121,
    viewBox: "0 0 287 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.959 22.1324C160.205 22.3178 177.291 34.2269 177.163 48.6889C177.034 63.1509 159.687 74.7182 138.474 74.5229C117.228 74.3376 100.142 62.4285 100.27 47.9665C100.399 33.5045 117.746 21.9372 138.959 22.1324Z",
    fill: "url(#paint0_linear_14_3638)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M177.124 54.4698L177.163 48.6889C177.034 63.1509 159.687 74.7182 138.474 74.523C117.228 74.3376 100.109 62.4384 100.27 47.9665L100.232 53.7474C100.103 68.2094 117.222 80.1086 138.435 80.3038C159.681 80.4892 176.996 68.9318 177.124 54.4698Z",
    fill: "url(#paint1_linear_14_3638)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M138.965 23.8047C158.074 23.9927 173.471 34.6661 173.34 47.7041C173.21 60.7422 157.611 71.1413 138.502 70.9532C119.392 70.7651 103.996 60.0917 104.126 47.0537C104.267 34.0483 119.855 23.6166 138.965 23.8047Z",
    fill: "url(#paint2_linear_14_3638)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M138.969 24.7648C157.863 24.9466 173.083 35.3884 173.337 48.1679C173.363 48.0177 173.347 47.8446 173.373 47.6943C173.503 34.6563 158.107 23.9829 138.997 23.7948C119.888 23.6067 104.299 34.0385 104.159 47.0439C104.175 47.2169 104.182 47.3574 104.166 47.5403C104.656 34.7501 120.075 24.583 138.969 24.7648Z",
    fill: "#A86314"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M247.915 34.2386C226.87 37.1981 209.307 35.7605 208.624 31.0158C207.942 26.2712 224.477 20.0416 245.49 17.0919C266.535 14.1323 284.099 15.57 284.781 20.3147C285.463 25.0593 268.961 31.2791 247.915 34.2386Z",
    fill: "url(#paint3_linear_14_3638)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M247.872 33.8597C228.939 36.503 213.098 35.2232 212.521 30.9455C211.911 26.6776 226.787 21.0903 245.71 18.4143C264.643 15.771 280.485 17.0507 281.062 21.3285C281.672 25.5963 266.795 31.1838 247.872 33.8597Z",
    fill: "url(#paint4_linear_14_3638)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M247.8 33.383C229.213 35.9932 213.639 34.7751 212.484 30.7071C212.472 30.7823 212.501 30.8802 212.488 30.9554C213.098 35.2232 228.907 36.5129 247.84 33.8696C266.773 31.2262 281.639 25.6062 281.029 21.3383C281.01 21.273 280.98 21.1751 280.96 21.1098C281.021 25.3294 266.387 30.7728 247.8 33.383Z",
    fill: "#A86314"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M207.975 26.2613L208.625 31.0158C207.942 26.2711 224.477 20.0415 245.49 17.0918C266.535 14.1323 284.099 15.57 284.781 20.3146L284.131 15.5601C283.449 10.8155 265.886 9.3778 244.84 12.3373C223.827 15.287 207.293 21.5167 207.975 26.2613Z",
    fill: "url(#paint5_linear_14_3638)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7142 44.5111C84.1276 56.6778 89.936 78.4317 79.6732 93.0634C69.4202 107.728 47.0114 109.709 29.598 97.5425C12.1846 85.3758 6.37625 63.6218 16.6391 48.9902C26.9019 34.3586 49.3334 32.3346 66.7142 44.5111Z",
    fill: "url(#paint6_linear_14_3638)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8788 47.1654C80.5368 58.1161 85.7612 77.6956 76.5547 90.8693C67.3155 104.053 47.1665 105.852 31.5085 94.9011C15.8505 83.9505 10.6263 64.3709 19.8327 51.1972C29.0392 38.0236 49.2208 36.2148 64.8788 47.1654Z",
    fill: "url(#paint7_linear_14_3638)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M76.374 97.8326L79.683 93.0959C69.43 107.76 47.0212 109.742 29.6078 97.575C12.1944 85.4084 6.38606 63.6544 16.6489 49.0228L13.3398 53.7594C3.08685 68.4237 8.88539 90.145 26.2988 102.312C43.7122 114.478 66.1438 112.454 76.374 97.8326Z",
    fill: "url(#paint8_linear_14_3638)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3051 47.9794C79.8258 58.829 85.0693 78.1179 76.2188 91.2911C76.3199 91.1538 76.4308 91.0491 76.4992 90.9217C85.7383 77.7382 80.5141 58.1586 64.8234 47.2178C49.1654 36.2671 28.9837 38.0759 19.7772 51.2496C19.6762 51.3869 19.6078 51.5143 19.5067 51.6516C28.8769 38.7848 48.8171 37.12 64.3051 47.9794Z",
    fill: "#7E470D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_3638",
    x1: 138.489,
    y1: 75.3011,
    x2: 139.019,
    y2: 17.8772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3912F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14_3638",
    x1: 180.889,
    y1: 64.713,
    x2: 110.301,
    y2: 64.0614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1216,
    stopColor: "#FFEE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2011,
    stopColor: "#FFFFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2776,
    stopColor: "#FFFFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3693,
    stopColor: "#FFCF5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4784,
    stopColor: "#9A5A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6514,
    stopColor: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A86314"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14_3638",
    x1: 137.416,
    y1: 143.386,
    x2: 139.337,
    y2: 4.63433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459,
    stopColor: "#FFDF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE7A22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14_3638",
    x1: 245.487,
    y1: 16.8479,
    x2: 248.123,
    y2: 35.6307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3912F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_14_3638",
    x1: 240.945,
    y1: -15.512,
    x2: 249.331,
    y2: 44.2442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459,
    stopColor: "#FFDF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE7A22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_14_3638",
    x1: 205.737,
    y1: 24.6238,
    x2: 288.528,
    y2: 13.0051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1216,
    stopColor: "#FFEE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2011,
    stopColor: "#FFFFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2776,
    stopColor: "#FFFFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3693,
    stopColor: "#FFCF5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4784,
    stopColor: "#9A5A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6514,
    stopColor: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A86314"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_14_3638",
    x1: 56.3469,
    y1: 59.3618,
    x2: 32.2977,
    y2: 93.7424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE7A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_14_3638",
    x1: 14.8325,
    y1: 118.71,
    x2: 64.2304,
    y2: 48.0915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9A83D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C5110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_14_3638",
    x1: 70.2855,
    y1: 109.785,
    x2: 8.38961,
    y2: 66.4889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE7A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1216,
    stopColor: "#E9A83D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2191,
    stopColor: "#FFFFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2776,
    stopColor: "#FFFFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3693,
    stopColor: "#FFCF5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3821,
    stopColor: "#E6B248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3992,
    stopColor: "#CB9235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4169,
    stopColor: "#B57925"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4354,
    stopColor: "#A6681B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4552,
    stopColor: "#9D5D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4784,
    stopColor: "#9A5A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5355,
    stopColor: "#9F5F15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6015,
    stopColor: "#AD6D1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#C48429"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7451,
    stopColor: "#E4A43B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7956,
    stopColor: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C5110"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin2);
export default __webpack_public_path__ + "static/media/coin2.2efd74ebb578645ef4be519633d0ad90.svg";
export { ForwardRef as ReactComponent };